<template>
  <div :class="['o-modal-bg','animated', animation]" >

      <div class="" :style="modalStyle">
        <div role="dialog" style="display:block">
        <div :class="{'modal-dialog': true, 'modal-lg': true, 'scroll-type': true,  'full': isFull}" role="document" :style="contentStyle" >

            <div class="modal-content">
              <div class="modal-header">
                <h2 class="modal-title">{{title}}</h2>
                <!-- .btn-resize 클릭 시, .modal-lg에 full클래스 토글 -->
                <!--button class="btn btn-md flat btn-modal-size large" v-on:click="largeSize"><i class="icon-lineIcon-resize-large mr-10"></i>크게보기</button>
                <button class="btn btn-md flat btn-modal-size small" v-on:click="smallSize"><i class="icon-lineIcon-resize-small mr-10"></i>작게보기</button-->
                <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close" v-on:click="close" style="cursor: pointer;">
                <i class="icon-close"></i>
                </button>
              </div>
              <div class="modal-body" :style="modalBodyStyle" style="max-height: 600px; overflow: auto">
                  <component :is="view" ref="content" v-bind="props" :mode="mode" :data="data" :opener="opener" @close="close" :key="id"></component>   
              </div>
              <div class="modal-footer" v-if="showBottom">
                  <div class="btn-wrap">
                  <button class="btn btn-md flat" data-dismiss="modal" aria-label="Close" v-on:click="close">
                      <i class="icon-lineIcon-close mr-5"></i>{{cancelName ? cancelName : '취소'}}
                  </button>
                  <button class="btn btn-md black" v-on:click="confirm">
                      <i class="icon-lineIcon-check mr-5"></i>{{confirmName ? confirmName : '완료'}}
                  </button>
                  </div>
                </div>
              </div>
            </div>
        </div>   
      </div>
  </div>
</template>
<script>
import {EventBus} from '@/components/common/eventBus';
export default {
  props: {
    view : {},
    side: {}, 
    props: {}, 
    mode: {}, 
    data: {}, 
    opener: {}, 
    modalStyle: {}, 
    title: {}, 
    contentStyle: {}, 
    modalBodyStyle: {}, 
    confirmName: {}, 
    cancelName: {}, 
    id: {}, 
    showBottom : {
      type: Boolean,
      default: true
    }
  },
  data: function() { 
    return {
      EventBus: null,
      animation: 'slideInRightAnimation',
      isFull: false
    };
  },
  created () {
    if(this.close)
      this.$root.$on("closeModal", this.close)
  },
  mounted () {
    this.animation = this.side ? 'slideInRightAnimation' : 'fadeInAnimation' 
    /*
      setTimeout(()=>{
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'dark-thick',
      });

    },300)
    */
  },
  methods: {
    smallSize(){
      this.isFull = false;
      EventBus.$emit('modalResize');
    },
    largeSize(){
      this.isFull = true;
      EventBus.$emit('modalResize');
    },
    close(event) {
      
      let removeIndex = -1
      if(this.$refs.content.$destroy)
        this.$refs.content.$destroy();
      this.$refs.content.$forceUpdate();
      this.$parent.modals.forEach((item,index) => {
        removeIndex = index
      })
      if(removeIndex > -1){
        this.animation = this.side ? 'slideOutRightAnimation' : 'fadeOutAnimation'
        setTimeout(() => {
          this.$parent.modals.pop(removeIndex)
        },300)
      }
    },
    confirm(event){
      if(this.$refs.content.modalConfirm){
        this.$refs.content.modalConfirm.call();
      }
    }

  }
};
</script>